import { Constants } from "../constants";
import type { RolePermissionItem } from "../../redux/slices/user/Types";

export type SessionPermissionAction = "edit" | "view" | "na";

export function normalizePermissionAction(
  raw: string | undefined | null
): SessionPermissionAction {
  const v = String(raw ?? "NA").trim().toLowerCase();
  if (v === "edit") return "edit";
  if (v === "view") return "view";
  return "na";
}

/** Backend groups permissions by portal (e.g. admin, partner) then module name. */
export function flattenRolePermissionsForPortal(
  data: Record<string, Record<string, RolePermissionItem[]>> | undefined,
  portalKey: string
): Record<string, SessionPermissionAction> {
  const map: Record<string, SessionPermissionAction> = {};
  if (!data || typeof data !== "object") return map;

  const portalData = data[portalKey];
  if (!portalData || typeof portalData !== "object") return map;

  for (const rows of Object.values(portalData)) {
    if (!Array.isArray(rows)) continue;
    for (const row of rows) {
      if (row?.permission_key) {
        map[row.permission_key] = normalizePermissionAction(row.action);
      }
    }
  }
  return map;
}

/** True when roles.type from User Management is HID or Super Admin. */
export function isAdminPortalRoleType(roleType: unknown): boolean {
  const normalized = String(roleType ?? "").trim().toLowerCase();
  return normalized === "hid" || normalized === "super admin";
}

/**
 * HID / Super Admin roles use the admin portal matrix; Partner type uses partner.
 * Legacy fallback: HID_USER_ROLES name list when role_type is missing.
 */
export function getPermissionPortalKey(
  role?: string | null,
  roleType?: string | null
): "admin" | "partner" {
  if (roleType) {
    return isAdminPortalRoleType(roleType) ? "admin" : "partner";
  }
  if (!role) return "partner";
  return Constants.HID_USER_ROLES.includes(role) ? "admin" : "partner";
}
